import React, {Component} from 'react'
import { Container, Row, Col } from 'reactstrap'
import logo from '../../../../assets/img/portal/tolautfoter.png';
import TernakPng from '../../../../assets/img/portal/ternak.png'
import BarangPng from '../../../../assets/img/portal/barang.png'

class Footer extends Component {
  constructor(props){
    super()
    this.state= {
      barang : "https://play.google.com/store/apps/details?id=com.lcskemenhub",
      ternak : "https://play.google.com/store/apps/details?id=com.project_lcs_ternak"
    }
  }
  componentDidMount(){
    if(navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      this.setState({barang :"market://details?id=com.lcskemenhub", ternak:"market://details?id=com.project_lcs_ternak"})
    }
  }
  render(){
    return(
      <div style={{backgroundColor:'#2759B7'}} className="text-white">
        <Container>
          <div className='d-flex justify-content-between p-4'>
            <div>
              <img src={logo} alt="shipper" className='d-block ml-auto mr-auto' width='100'/>
            </div>
            <div className='d-flex' >
              <div className='rounded-circle p-1 text-center mr-4' style={{ background: "rgba(217, 217, 217, 0.35)", fontSize: "12px",width: "25px",height: "25px"}} >
                <i className="fa fa-facebook" aria-hidden="true"></i>
              </div>
              <div className='rounded-circle p-1 text-center mr-4' style={{ background: "rgba(217, 217, 217, 0.35)", fontSize: "12px",width: "25px",height: "25px"}} >
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </div>
              <div className='rounded-circle p-1 text-center mr-4' style={{ background: "rgba(217, 217, 217, 0.35)", fontSize: "12px",width: "25px",height: "25px"}} >
                <i className="fa fa-instagram" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <hr style={{borderColor:'#ffff'}} className="mt-0"/>
          <Row className="mb-4">
            <Col xs="12" lg="8">
              <Row>
                {this.props.props.portalGetListPage && this.props.props.portalGetListPage.data.map((val,i)=>(
                  <Col key={i}>
                    <strong>
                      {val.label}
                    </strong>
                    {val.submenu.map((data, id)=> (
                      <div style={{fontSize:'10px'}} onClick={() => this.props?.props.history.push(`/detail/${data.label.replaceAll(" ", "-").toLowerCase()}`)}  key={id} className="text-muted">
                        <span style={{cursor:'pointer'}}>{data.label}</span>
                      </div>
                    ))}
                    {i === 0 &&
                      <div style={{fontSize:'10px'}} onClick={() => this.props?.props.history.push(`/biaya-pengiriman`)} className="text-muted">
                        <span style={{cursor:'pointer'}}>Biaya Pengiriman</span>
                      </div>
                    }
                  </Col>
                ))}
              </Row>
            </Col>
            <Col xs="12" lg="4">
              <div className='mb-3'>
                <div className='mb-1'>
                  <strong>Kontak Kami</strong>
                </div>
                <div style={{fontSize:'10px'}} className="text-muted">
                  {/* <i className="fa fa-headphones" aria-hidden="true"></i> */}
                  <img 
                    src={ require('../../../../assets/img/logo-whatsapp.png')} 
                    width={"15px"} 
                    style={{marginBottom: "4px"}}
                  />{" "}
                  0812994812374
                </div>
                <div style={{fontSize:'10px'}} className="text-muted">
                  <i className="fa fa-envelope" aria-hidden="true"></i> helpdesk@sitolaut.com
                </div>
              </div>
              <div>
                <strong>
                  Unduh Sitolaut Barang & Ternak
                </strong>
                <div style={{marginTop:'10px'}}>
                  <a href={this.state.barang}>
                    <img src={BarangPng} alt="shipper" className='ml-auto mr-auto' width='90'/>
                  </a>
                  {' '}
                  <a href={this.state.ternak}>
                    <img src={TernakPng} alt="shipper" className='ml-auto mr-auto' width='90'/>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
          <hr style={{borderColor:'#ffff'}}/>
          <div style={{paddingBottom:'15px'}}>
            <strong className="text-muted" style={{fontSize:'10px', marginBottom:'0px'}}>Copyright &copy; 2020 Sitolaut Dephub</strong>
          </div>
        </Container>
      </div>
    )
  }
}

export default Footer